import Dexie from 'dexie';

const fuelerDB = new Dexie('fueler');

// You must keep versions around as long as there are users
// who use a previous version.
fuelerDB.version(1).stores({
    apparatuses: 'departmentApparatusID',
    user: 'id',
    logs: '++'
});

export default fuelerDB;


// WEBPACK FOOTER //
// ./src/lib/fuelerDB.js